'use client';

import React from 'react';
import { CloseIcon, SearchIcon } from '../Atoms/Icons';
import PlaceAutocomplete from './PlaceAutocomplete';
import type {
  PlaceAutocompleteCallback,
  PlaceAutocompleteOwnOptions,
} from './PlaceAutocomplete/usePlaceAutocomplete';
import useLocationSearchFilter from './useLocationSearchFilter';

export interface LocationSearchFieldProps extends Partial<PlaceAutocompleteOwnOptions> {
  handle: string;
  // A field handle to use when searching by state
  stateHandle?: string;
  range?: number;
}

const LocationSearchField = ({
  handle,
  stateHandle,
  range,
  options,
  onSelect,
}: LocationSearchFieldProps) => {
  const ref = React.useRef<HTMLInputElement>(null);

  const filter = useLocationSearchFilter({
    fieldHandle: handle,
    stateFieldHandle: stateHandle,
    range,
  });

  const hasValue = !!filter.value;

  const handleChange: PlaceAutocompleteCallback = (data, place) => {
    filter.handleChange(data, place);
    onSelect?.(data, place);
  };

  return (
    <PlaceAutocomplete ref={ref} options={options} onSelect={handleChange}>
      {({ inputProps, clearValue }) => (
        <label className="text-2xl font-medium">
          Location
          <div className="relative">
            <input
              className="focus:border-midnight-blue-500 focus:ring-midnight-blue-500 form-input block w-full rounded-lg border px-4 py-2 text-base text-tBase md:w-auto md:min-w-96"
              type="text"
              placeholder={'Search suburb, postcode or state'}
              {...inputProps}
            />
            {hasValue ? (
              <div
                className="absolute inset-y-0 right-3 flex h-full cursor-pointer items-center"
                onClick={clearValue}>
                <CloseIcon className="stroke-bgPrimary" />
              </div>
            ) : (
              <div className="pointer-events-none absolute inset-y-0 right-3 flex h-full items-center">
                <SearchIcon />
              </div>
            )}
          </div>
        </label>
      )}
    </PlaceAutocomplete>
  );
};

export default LocationSearchField;
